import { colors } from '@/theme/colors';

export default function FlexcarBrandmarkYuge() {
  return (
    <svg
      width="222"
      height="207"
      viewBox="0 0 222 207"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3942_3705)">
        <mask
          id="mask0_3942_3705"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="348"
          height="295"
        >
          <rect width="348" height="294.754" fill="url(#paint0_linear_3942_3705)" />
        </mask>
        <g mask="url(#mask0_3942_3705)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M174 338.662C264.064 338.662 337.074 265.307 337.074 174.82C337.074 84.3319 264.064 10.977 174 10.977C83.9365 10.977 10.9256 84.3319 10.9256 174.82C10.9256 265.307 83.9365 338.662 174 338.662ZM348 174.82C348 271.37 270.098 349.639 174 349.639C77.9025 349.639 0 271.37 0 174.82C0 78.2694 77.9025 0 174 0C270.098 0 348 78.2694 348 174.82Z"
            fill={colors.neutral100}
          />
          <path
            d="M142.93 64.6063C142.145 63.1754 139.268 58.7659 134.792 58.7659H96.1933C94.8005 58.717 93.4432 59.2135 92.4076 60.1505C91.372 61.0874 90.7389 62.3918 90.6418 63.7886C90.6921 64.6242 90.9413 65.4354 91.3685 66.154L147.581 162.025L91.3103 258.1C90.9074 258.793 90.678 259.575 90.6418 260.377C90.739 261.772 91.3731 263.073 92.4096 264.005C93.446 264.938 94.8033 265.427 96.1933 265.371H134.792C139.268 265.371 142.174 260.815 142.93 259.53L199.869 162.025L142.93 64.6063Z"
            fill={colors.neutral100}
          />
          <path
            d="M251.55 58.6522H212.951C208.475 58.6522 205.597 63.2077 204.813 64.4926L182.781 102.455L208.94 147.193L256.432 65.8359C256.841 65.1534 257.08 64.3822 257.13 63.5873C257.005 62.2037 256.356 60.921 255.318 60.003C254.28 59.085 252.931 58.6016 251.55 58.6522Z"
            fill={colors.neutral100}
          />
          <path
            d="M256.374 257.986L208.94 176.804L182.781 221.6L204.9 259.563C205.685 260.964 208.562 265.403 213.038 265.403H251.55C252.943 265.46 254.303 264.971 255.344 264.04C256.385 263.108 257.026 261.806 257.13 260.41C257.079 259.552 256.82 258.72 256.374 257.986Z"
            fill={colors.neutral100}
          />
        </g>
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_3942_3705"
          x1="174"
          y1="1.5992e-05"
          x2="22.5"
          y2="155.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={colors.gradientBrandmark} stopOpacity="0.8" />
          <stop offset="1" stopColor={colors.gradientBrandmark2} stopOpacity="0" />
        </linearGradient>
        <clipPath id="clip0_3942_3705">
          <rect width="222" height="207" fill={colors.neutral100} />
        </clipPath>
      </defs>
    </svg>
  );
}
